import { render, staticRenderFns } from "./LoginsManagement.vue?vue&type=template&id=5850caac&scoped=true"
import script from "./LoginsManagement.vue?vue&type=script&lang=js"
export * from "./LoginsManagement.vue?vue&type=script&lang=js"
import style0 from "./LoginsManagement.vue?vue&type=style&index=0&id=5850caac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850caac",
  null
  
)

export default component.exports